import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const SuccessMessage = ({
    border = '#377712',
    bg = '#ECFDF3',
    iconColor = '#12AF53',
    hasBorderOpacity = true,
    className,
}) => {
    return (
        <svg
            className={clsx(className ? className : 'm-auto')}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="48" height="48" rx="24" fill={bg} />
            <path
                d="M17 25L21 29L31 19"
                stroke={iconColor}
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect
                x="3.5"
                y="3.5"
                width="41"
                height="41"
                rx="20.5"
                stroke={border}
                strokeOpacity={hasBorderOpacity ? '0.1' : '1'}
                strokeWidth="7"
            />
        </svg>
    )
}

SuccessMessage.propTypes = {
    iconColor: PropTypes.string,
    bg: PropTypes.string,
    border: PropTypes.string,
    hasBorderOpacity: PropTypes.bool,
    className: PropTypes.string,
}

export default SuccessMessage
